import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let EdadfortyService = class EdadfortyService {
    constructor(http) {
        this.http = http;
        this.cargadoEdadforty = true;
        this.edadforty = [];
        this.edadfortyRFL = [];
        this.edadfortyRFC = [];
        this.edadfortyRFP = [];
        this.edadfortyRCL = [];
        this.edadfortyRCC = [];
        this.edadfortyRCP = [];
        this.edadfortyRCC_PSen = [];
        this.edadfortyRCC_PSec = [];
        this.cargarEdadforty();
    }
    cargarEdadforty() {
        return new Promise((resolve, reject) => {
            this.http.get('assets/data/dataLineas.json')
                .subscribe((resp) => {
                this.edadforty = resp;
                this.edadfortyRFL = this.edadforty[2].rutinafacial.limpieza;
                this.edadfortyRFC = this.edadforty[2].rutinafacial.cuidado;
                this.edadfortyRFP = this.edadforty[2].rutinafacial.proteccion;
                this.edadfortyRCL = this.edadforty[2].rutinacorporal.limpieza;
                this.edadfortyRCC = this.edadforty[2].rutinacorporal.cuidado;
                this.edadfortyRCP = this.edadforty[2].rutinacorporal.proteccion;
                this.edadfortyRCC_PSen = this.edadforty[2].rutinacorporal.cuidado_piel_sensible;
                this.edadfortyRCC_PSec = this.edadforty[2].rutinacorporal.cuidado_piel_seca;
                setTimeout(() => {
                    this.cargadoEdadforty = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    }
};
EdadfortyService.ctorParameters = () => [
    { type: HttpClient }
];
EdadfortyService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], EdadfortyService);
export { EdadfortyService };
//# sourceMappingURL=edadforty.service.js.map